import { render, staticRenderFns } from "./knit_stock_report.vue?vue&type=template&id=0d56b0eb&scoped=true"
import script from "./knit_stock_report.vue?vue&type=script&lang=js"
export * from "./knit_stock_report.vue?vue&type=script&lang=js"
import style0 from "./knit_stock_report.vue?vue&type=style&index=0&id=0d56b0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56b0eb",
  null
  
)

export default component.exports